import { TextTemplateClient } from './TextTemplates'
import store from 'src/store'

export class QuoteTextTemplateClient extends TextTemplateClient {
  /**
   * QuoteTextTemplates constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/quote-text-templates`
  }
}
